/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Preference_InvalidInputs */

const en_error_preference_invalid = /** @type {(inputs: Error_Preference_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email can no longer be turned off.`)
};

/**
* | output |
* | --- |
* | "This email can no longer be turned off." |
*
* @param {Error_Preference_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_preference_invalid = /** @type {((inputs?: Error_Preference_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Preference_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_preference_invalid(inputs)
});